import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { SpotifyArtistInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyArtistProps {
  artist: SpotifyArtistInfo;
}

const SpotifyArtistList: React.FC<SpotifyArtistProps> = ({ artist }) => {
  return (
    <div className="flex flex-col mx-4 mt-4 text-left mb-8">
      <div className="text-white font-bold">여러 장소 리스트</div>

      <HorizontalScrollableContainer>
        <div className="flex space-x-4 -ml-4">
          {artist.images.map((content, index) => (
            <div key={index} className="w-32 h-40">
              <img
                src={artist.images[index]}
                alt={`Thumbnail ${index + 1}`}
                className="w-32 h-32 object-cover rounded-full mb-1"
              />
              <div className="text-white font-bold text-md">
                {artist.titles[index]}
              </div>
              <div className="text-gray-500 text-sm">
                {artist.captions[index]}
              </div>
            </div>
          ))}
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default SpotifyArtistList;
